// Preserve the API's decimal strings, including amounts above Number's precision.
export function formatContributionMoney(value: string | null, currency: string): string {
  if (value === null) return 'Brak danych';
  const negative = value.startsWith('-');
  const [whole, fraction = ''] = (negative ? value.slice(1) : value).split('.');
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
  const decimals = fraction.replace(/0+$/, '').padEnd(2, '0');
  return `${negative ? '-' : ''}${grouped},${decimals} ${currency}`;
}
